import { ReturnBtn } from "../../components/Button/styles";
import { Container, Title } from "../Login/styles";
import { GreyLine } from "../../components/GreyLine/styles";
import { Tech } from "../../components/Techs/styles";
import AddTechModal from "../../components/AddTechModal";
import NoTechs from "../../components/NoTechs";
import { useHistory } from "react-router-dom";
import EditTechModal from "../../components/EditTechModal";
import {
  HomeDiv,
  HomeDiv2,
  HomeDiv3,
  HomeDiv4,
  HomeDiv5,
} from "../../components/HomeDiv/styles";

function Home({
  isAdding,
  setIsAdding,
  user,
  setUser,
  isEdit,
  setIsEdit,
  tec,
  setTec,
}) {
  const history = useHistory();
  function handleLogout() {
    localStorage.clear();
    history.push("/");
  }

  return (
    <Container>
      <HomeDiv>
        <Title color="#FF577F" fontSize="25px">
          Kenzie Hub
        </Title>
        <ReturnBtn onClick={() => handleLogout()} fontSize="18px">
          Sair
        </ReturnBtn>
      </HomeDiv>

      <GreyLine />
      <HomeDiv2>
        <Title color="white" fontSize="20px">
          Olá, {user.name}
        </Title>
        <Title color="#868E96" fontSize="13">
          {user.course_module}
        </Title>
      </HomeDiv2>
      <GreyLine />
      <HomeDiv3>
        <HomeDiv4>
          <Title color="white" fontSize="18px">
            Tecnologias
          </Title>
          <ReturnBtn
            onClick={() => (isAdding ? setIsAdding(false) : setIsAdding(true))}
            fontSize="26px"
          >
            +
          </ReturnBtn>
          {isEdit && (
            <EditTechModal
              user={user}
              setUser={setUser}
              tec={tec}
              setIsEdit={setIsEdit}
            />
          )}
          {isAdding && (
            <AddTechModal
              isAdding={isAdding}
              setIsAdding={setIsAdding}
              user={user}
              setUser={setUser}
            />
          )}
        </HomeDiv4>
        <HomeDiv5>
          {user.techs?.length > 0 ? (
            user.techs.map((tech) => {
              return (
                <Tech
                  onClick={() => {
                    setTec(tech);
                    setIsEdit(true);
                  }}
                  key={tech.id}
                >
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {tech.title}{" "}
                    <p style={{ fontSize: "14px", color: "#868E96" }}>
                      {tech.status}
                    </p>
                  </div>
                </Tech>
              );
            })
          ) : (
            <NoTechs />
          )}
        </HomeDiv5>
      </HomeDiv3>
    </Container>
  );
}
export default Home;
